import { useMutation, useQueryClient } from "@tanstack/react-query";
import { storiesKeys } from "Api/Queries/Stories/useStoriesQuery";
import { storyPostUsageKeys } from "Api/Queries/Stories/useStoryPostUsageQuery";
import { deleteStoriesPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

/** Hard delete; a live story is pulled from viewers' timelines first, server-side. */
export const useDeleteStoryMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      deleteStoriesPublicID(publicID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: storiesKeys.all });
      // Deleting frees the quota slot (hard delete by design).
      queryClient.invalidateQueries({ queryKey: storyPostUsageKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
